import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiLock, FiArrowLeft, FiShield } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

const AccessDenied = ({ message = 'You do not have permission to view this page.' }) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="w-20 h-20 bg-red-50 border-2 border-red-200 rounded-2xl flex items-center justify-center mb-6">
        <SafeIcon icon={FiLock} className="text-4xl text-red-500" />
      </div>
      <h2 className="text-2xl font-bold text-slate-800 mb-2">Access Restricted</h2>
      <p className="text-slate-500 max-w-md mb-2">{message}</p>
      <p className="text-sm text-slate-400 mb-8">
        Your current role is <span className="font-semibold text-slate-600">{currentUser.role}</span>. Contact your administrator to request access.
      </p>
      <div className="flex gap-3">
        <button onClick={() => navigate(-1)} className="flex items-center gap-2 px-5 py-2.5 bg-white border border-slate-200 text-slate-700 rounded-xl hover:bg-slate-50 font-medium text-sm transition-colors shadow-sm">
          <SafeIcon icon={FiArrowLeft} /> Go Back
        </button>
        <button onClick={() => navigate('/')} className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white rounded-xl hover:bg-blue-700 font-medium text-sm transition-colors shadow-sm">
          <SafeIcon icon={FiShield} /> Go to Dashboard
        </button>
      </div>
    </motion.div>
  );
};
export default AccessDenied;